import { Component, Input } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { User } from '@app/state';
import { Roles } from '@app/state/user/user.constant';
import { AvatarComponent } from '@app/ui';
import { HeaderAccountMenuTone } from '../header-account-menu/header-account-menu.component';

export type HeaderUserProfileSize = 'sm' | 'md';

// The API's role keys are not words a person should read under their own name.
const ROLE_LABELS: Record<string, string> = {
  [Roles.superAdmin]: 'Super admin',
  [Roles.admin]: 'Admin',
  [Roles.editor]: 'Editor',
};

@Component({
  selector: 'gb-header-user-profile',
  standalone: true,
  imports: [AvatarComponent, TitleCasePipe],
  templateUrl: './header-user-profile.component.html',
})
export class HeaderUserProfileComponent {
  @Input({ required: true }) user: User | null = null;
  @Input() isLoading = false;
  @Input() size: HeaderUserProfileSize = 'md';
  @Input() tone: HeaderAccountMenuTone = 'default';

  get roleLabel(): string {
    const role = this.user?.role ?? '';
    return ROLE_LABELS[role] ?? role;
  }

  get displayName(): string {
    return `${this.user?.first_name || ''} ${this.user?.last_name || ''}`.trim();
  }
}
